// src/hooks/usePushAutoRegister.js
import { useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient";
import { restorePushSubscriptionIfAllowed } from "../lib/pwa/pushClient";

export function usePushAutoRegister({ enabled = true } = {}) {
  const [userId, setUserId] = useState(null);
  const ranForUserRef = useRef(null);

  useEffect(() => {
    let alive = true;

    const loadUser = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (alive) {
        setUserId(user?.id || null);
      }
    };

    loadUser();

    const { data: authSubscription } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        const nextUserId = session?.user?.id || null;

        ranForUserRef.current = null;
        setUserId(nextUserId);
      }
    );

    return () => {
      alive = false;
      authSubscription?.subscription?.unsubscribe?.();
    };
  }, []);

  useEffect(() => {
    let alive = true;

    const register = async () => {
      if (!enabled || !userId) return;
      if (ranForUserRef.current === userId) return;

      ranForUserRef.current = userId;

      try {
        await restorePushSubscriptionIfAllowed();
      } catch (error) {
        if (!alive) return;

        console.warn(
          "[usePushAutoRegister] registration failed:",
          error?.message || error
        );
      }
    };

    register();

    return () => {
      alive = false;
    };
  }, [enabled, userId]);
}